module.exports = __webpack_public_path__ + "img/Sint Maarten (Netherlands).ba8c34e5.svg";